<template>
  <div class="news-story">
    <div class="two-columns">
      <div class="pic-column" v-if="news.tile_image">
        <img :src="getImageUrl(news.tile_image, '700')" :alt="news.images[0].alt" :class="{loaded: imloaded}" class="ntimage" />
      </div>
      <div class="text-column">
        <template v-if="inpage">
          <h1>{{ news.title }}</h1>
          <h2 v-html="news.summary"></h2>
        </template>
        <template v-else>
          <div class="h2">{{ news.title }}</div>
          <div class="summary" v-html="news.summary"></div>
        </template>
        <div class="body" v-html="fbody" ref="pbody"></div>
        <div class="tag-panel">
          <div class="tag" v-for="tag in tags" :key= "tag" v-on:click.stop="handleTag(tag)">{{ tag }}</div>
        </div>
        <div class="social-panel">
          <social-panel :url="url" :media="media" :message="message" :caption="news.title" />
        </div>
        <div v-if="!inpage">
          <div class="permalink" ><ix-router-link :to="news.permalink">permalink</ix-router-link></div>
        </div>
      </div>
    </div>
    <div class="extra-pics" v-if="(picCount > 1) && (imloaded)">
      <div v-for="pic in extrapics" :key="pic.filename" class="impic">
        <img :src="getImageUrl(pic.filename, '700')" :alt="pic.alt" />
      </div>
    </div>
  </div>
</template>

<script>
import SocialPanel from '@/components/panels/SocialPanel.vue'

export default {
  components: {
    SocialPanel
  },
  props: {
    newsid: String,
    inportfolio: Boolean,
    inpage: Boolean
  },
  data () {
    return {
      news: {},
      picCount: 0,
      fbody: '',
      tags: [],
      message: 'Seen on IllustrationX',
      loaded: false,
      imloaded: false,
      extrapics: []
    }
  },
  computed: {
    media () {
      if(this.newsid){
        return this.getImageUrl(this.news.tile_image, '700')
      }
      return ''
    },
    url () {
      if(this.loaded) {
        return this.news.permalink
      }
      return ''
    }
  },
  created () {
    this.loaded = false
    if(!this.inportfolio) {
      if(this.newsid) {
        this.loadData()
      }
    }
  },
  methods: {
    getImageUrl(name, stype) {
      return this.$k.imagebase + 'images/news/' + this.news.news_id + '/' + stype + '/' + name
    },
    replaceImageLink (src) {
      if(src.indexOf('=') < 0) return src
      let name = src.split('=').pop()
      return this.getImageUrl(name, '500')
    },
    async processImagesAndLinks () {
      let ims = this.$refs.pbody.querySelectorAll('img')
      if(ims.length > 0) {
        ims.forEach(im => {
          if(im.src) {
            let res = this.replaceImageLink(im.src)
            im.src = res
          }
        })
      }
      let links = this.$refs.pbody.querySelectorAll('a')
      let locs = window.location.href.split('/')
      let wad = locs[0] + '//' + locs[2] + '/'
      links.forEach(link => {
        if(link.href) {
          let href = link.href
          if(href.startsWith('https://www.illustrationweb')) {
            link.href = wad + href.split('/').slice(3).join('/')
          }
        }
      })
    },
    async loadData () {
      console.log('am in loadData of NewsStory')
      this.imloaded = false
      let res = await this.$apix.get('news/byid/' + this.newsid)
      if(!res.data.title) {
        this.$k.goNotFound()
        return
      }
      this.loaded = true
      this.news = res.data
      if(this.inpage){
        this.$k.setMetatags(this.news.title, this.$k.stripHtml(this.news.summary))
      }
      
      if(this.news.images) {
        this.picCount = this.news.images.length
      }
      else {
        this.picCount = 0
      }
      if(this.picCount > 1) {
        this.extrapics = this.news.images.slice(1)
      }
      let fbody = this.news.body.replace(/Calibri;/g, '')
      this.fbody = fbody
      
      let tags = this.news.tags.split('#')
      this.tags = tags.filter(el => el !== '')
      this.$nextTick(() => {
        this.processImagesAndLinks()
      })
      if(this.news.tile_image){
         await this.$k.loadImage(this.getImageUrl(this.news.tile_image, '900'))
      }
      this.imloaded = true
      this.$emit('load', this.news)
    },
    handleTag(tag) {
      let t = '/news/tags/' + this.$k.tagToUrl(tag)
      this.$ixr.push(t)
    },
    handleClose () {
      if(this.inportfolio) {
        this.$emit('close')
      }
      else {
        if(this.$store.state.fromPage){
          if(this.$store.state.fromPage === '/'){
            this.$ixr.push('/news')
          }
          this.$router.push(this.$store.state.fromPage)
        }
        else {
          this.$ixr.push('/news')
        }
      }
    }
  },
  watch: {
    newsid () {
      this.loaded = false
      this.news = {}
      this.loadData()
    }
  }
}
</script>

<style scoped>
.ntimage{
  opacity:0;
  transition:opacity 0.4s linear;
}

.ntimage.loaded{
  opacity:1;
}


.news-story .extra-pics{
  display:flex;
  flex-wrap:wrap;
  justify-content: space-between;
  padding-bottom:45px;
}

.news-story .extra-pics .impic{
  width:49%;
  box-sizing: border-box;
  margin-bottom:10px;
}

.news-story .extra-pics .impic img{
  width:100%;
}

.two-columns{
  display:flex;
  padding-bottom:45px;
}

.two-columns .pic-column{
  width:49%;
}

.pic-column img{
  width:100%;
}

.two-columns .text-column{
  width:38%;
  margin-left:20px;
}

.text-column h1{
  width:auto;
}

.text-column h2{
  margin-top:0;
  color:#000;
  font-size:27px;
  font-weight:400;
}


.text-column .summary{
  font-size:27px;
}

.text-column .body{
  font-size:18px!important;
  line-height:24px;
}

.news-story a{
  color:#ce0e2d;
}

.news-story a:hover{
  text-decoration: underline;
}

.social-panel{
  margin:16px 0;
}

.permalink{
  font-size:14px;
  padding:2px 6px;
  display:inline-block;
  opacity:0.7;
}

.permalink:hover{
  opacity:1;
  background-color:#ce0e2d;
}

.permalink a{
  text-decoration: none;
}

.permalink:hover a{
  color:#fff;
  text-decoration: none;
}

@media screen and (max-width:768px) {
  .two-columns{
    display:block;
  }

  .two-columns .pic-column{
    width:100%;
  }

  .two-columns .text-column{
    width:100%;
    margin-left:0;
    margin-top:20px;
  }
}

@media screen and (max-width:640px) {

  .news-story .extra-pics{
    display:block;
  }

  .news-story .extra-pics .impic{
    width:100%;
    box-sizing: border-box;
    
  }

  .text-column h1{
    font-size: 32px;
    line-height:36px;
  }

  .text-column h2{
    font-size:22px;
  }
}
</style>